import {AppUrls} from 'shared/config/model/urls';

import {getMonitorLifecycleTexts, useMonitorDelete, useMonitorPause, useMonitorResume} from 'entities/monitor';
import {portIncidentAPI} from 'features/port/api/portIncidentAPI';
import {portMonitorAPI} from 'features/port/api/portMonitorAPI';
import {TypedDispatch} from 'shared/model/types';

import {IPortMonitorListItem} from './PortMonitor/IPortMonitor';

interface IMutationParams {
    item: Pick<IPortMonitorListItem, 'uuid'>,
    handleClose: () => void,
}

export const usePortMonitorPause = ({item, handleClose}: IMutationParams) => {
    const [stopPortMonitor, {isLoading}] = portMonitorAPI.useStopPortMonitorMutation();

    return useMonitorPause({
        request: () => stopPortMonitor(item.uuid).unwrap(),
        isLoading,
        handleClose,
        successText: getMonitorLifecycleTexts().paused,
    });
};

export const usePortMonitorResume = ({item, handleClose}: IMutationParams) => {
    const [startPortMonitor, {isLoading}] = portMonitorAPI.useStartPortMonitorMutation();

    return useMonitorResume({
        request: () => startPortMonitor(item.uuid).unwrap(),
        isLoading,
        handleClose,
        successText: getMonitorLifecycleTexts().resumed,
    });
};

const invalidatePortIncidents = (dispatch: TypedDispatch) => {
    dispatch(portIncidentAPI.util.invalidateTags(['PortIncident', 'SummaryPortIncident']));
};

export const usePortMonitorDelete = ({item, handleClose}: IMutationParams) => {
    const [deletePortMonitor, {isLoading}] = portMonitorAPI.useDeletePortMonitorMutation();

    return useMonitorDelete({
        request: () => deletePortMonitor(item.uuid).unwrap(),
        isLoading,
        handleClose,
        successText: getMonitorLifecycleTexts().deleted,
        listUrl: AppUrls.PORT_MONITORS,
        detailsRoute: AppUrls.PORT_MONITOR_DETAILS,
        withTags: true,
        onDeleted: invalidatePortIncidents,
    });
};
